<template>
  <div class="table-container">
    <a-card title="已生成报告列表">

      <a-table :columns="columns" :data-source="data" bordered>
        <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
          style="padding: 8px">
          <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`按 ${column.title} 搜索`" :value="selectedKeys[0]"
            style="width: 188px; margin-bottom: 8px; display: block;"
            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
            搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
            重置
          </a-button>
        </div>
        <a-icon slot="filterIcon" slot-scope="filtered" type="search"
          :style="{ color: filtered ? '#108ee9' : undefined }" />

        <template slot="customRender" slot-scope="text, record, index, column">
          <span v-if="searchText && searchedColumn === column.dataIndex">
            <template v-for="(fragment, i) in text
        .toString()
        .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
              <mark v-if="fragment.toLowerCase() === searchText.toLowerCase()" :key="i" class="highlight">{{ fragment
                }}</mark>
              <template v-else>{{ fragment }}</template>
            </template>
          </span>
          <template v-else>
            {{ text }}
          </template>
        </template>

        <span slot="tag" slot-scope="tag">
          <a-tag :color="tag === '严重' ? 'volcano' : tag === '中等' ? 'geekblue' : 'green'">
            {{ tag }}
          </a-tag>
        </span>
        <template slot="operation" slot-scope="text, record, index">
          <div class="row-operations">

            <span>

              <a @click="() => look(record.key)"> 查看</a>
              <a-divider type="vertical" />
              <a-popconfirm title="将会永久删除（真的很久！）" @confirm="() => dele(record.key)">
                <a style="color: red;">删除</a>
              </a-popconfirm>
            </span>
          </div>
        </template>
      </a-table>
    </a-card>
  </div>
</template>


<script>
const TEST_URL = process.env.VUE_APP_URL_REPORT_SERVICE
const columns = [
  {
    title: '编号',
    dataIndex: 'id',
    width: '8%',
    scopedSlots: { customRender: 'id' },
    sorter: (a, b) => parseInt(a.id, 10) - parseInt(b.id, 10),
  },
  {
    title: '标题',
    dataIndex: 'headline',
    width: '15%',
    scopedSlots: {
      filterDropdown: 'filterDropdown',
      filterIcon: 'filterIcon',
      customRender: 'headline',
    },
    onFilter: (value, record) =>
      record.headline
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => {
          this.searchInput.focus();
        });
      }
    },
  },
  {
    title: '生成日期',
    dataIndex: 'date',
    width: '10%',
    scopedSlots: { customRender: 'date' },
    sorter: (a, b) => new Date(a.date.replace(/\./g, '-')) - new Date(b.date.replace(/\./g, '-')),
  },
  {
    title: '摘要',
    dataIndex: 'summary',
    width: '55%',
    scopedSlots: {
      customRender: 'summary',
      filterDropdown: 'filterDropdown',
      filterIcon: 'filterIcon',
    },
    onFilter: (value, record) =>
      record.summary
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => {
          this.searchInput.focus();
        });
      }
    },
  },


  {
    title: '重要程度',
    key: 'tag',
    dataIndex: 'tag',
    align: 'center',
    scopedSlots: { customRender: 'tag' },
    width: '10%',
    filters: [{
      text: '普通',
      value: '普通',
    }, {
      text: '中等',
      value: '中等',

    }, {
      text: '严重',
      value: '严重',
    }],
    filterMultiple: true,
    onFilter: (value, record) => record.tag == value,
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    width: 200,
    align: 'center',
    fixed: 'right',
  },
];

const data = [];

import axios from 'axios';

export default {
  data() {
    this.cacheData = data.map(item => ({ ...item }));
    return {
      data,
      columns,
      editingKey: '',
      searchText: '',
      searchInput: null,
      searchedColumn: '',
    };
  },
  methods: {
    async fetchData() {
      try {
        const response = await axios.get(`${ TEST_URL }report/`);
        const jsonResponse = response.data;

        this.data = jsonResponse.map((item, index) => ({
          key: (index + 1).toString(),
          id: item.id.toString(),
          headline: item.headline,
          date: item.date.split('T')[0],
          summary: item.summary,
          body: item.body,
          tag: item.tag
        }));
      } catch (error) {
        console.error('Fetch error: ', error);
      }
    },

    async dele(key) {
      // 备份当前数据
      this.tempData = JSON.parse(JSON.stringify(this.data));

      const newData = [...this.data];
      const index = newData.findIndex(item => key === item.key);
      if (index > -1) {
        // 获取要删除的数据的 ID
        const idToDelete = newData[index].id;

        try {
          // 向后端发送 DELETE 请求删除数据
          await axios.delete(`http://localhost:8086/chart/report/${idToDelete}`);

          // 成功删除后更新前端数据
          const deletedItem = newData.splice(index, 1)[0];
          this.data = newData;

          // 显示删除成功的提示
          const notificationKey = `delete-notification-${key}`;
          this.$notification.open({
            message: '删除成功！',
            description: `已将${this.tempData[index].headline}删除，单击消息撤销！`,
            icon: <a-icon type="alert" style="color: lightblue" />,
            key: notificationKey,
            onClick: async () => {
              console.log('Notification Clicked!');
              try {
                // 恢复数据时向后端发送 POST 请求
                await axios.post(`http://localhost:8086/chart/report/restore`, deletedItem);
                // 恢复前端数据
                this.data = JSON.parse(JSON.stringify(this.tempData));
              } catch (restoreError) {
                console.error('Restore error: ', restoreError);
                this.$notification.error({
                  message: '恢复失败！',
                  description: `恢复表目 ${deletedItem.headline} 失败！`,
                  onClick: () => {
                    console.log('Notification Clicked!');
                  },
                });
              }
              // 关闭提示框
              this.$notification.destroy(notificationKey);
            },
          });
        } catch (error) {
          console.error('Delete error: ', error);
          this.$notification.error({
            message: '删除失败！',
            description: `删除表目 ${this.tempData[index].headline} 失败！`,
            onClick: () => {
              console.log('Notification Clicked!');
            },
          });
        }
      }
    },

    look(key) {
      const newData = [...this.data];
      const target = newData.find(item => key === item.key);
      
      this.$success({
        title: `${target.headline}`,
        // JSX support
        content: (
          <div>
            {target.body}
          </div>
        ),
      });
    },

    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },

    handleReset(clearFilters) {
      clearFilters();
      this.searchText = '';
    },

  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style scoped>
.table-container {
  background-color: white;
  padding: 20px;
}

.editable-row-operations a {
  margin-right: 8px;
}
</style>
